module.exports = __webpack_public_path__ + "static/media/project16.d2c15905.png";